define(['rest/utils', 'http', 'security', 'requester/urlBuilder', '../request/requestParamsFactory', 'lodash/core',
    '../request/contentTypeConfigurer', './asyncRedirectModeCallbackFactory'],
function(
    utils,
    http,
    security,
    urlBuilder,
    createRequestParams,
    _,
    contentTypeConfigurer,
    asyncRedirectModeCallbackFactory
) {

    return function(maxNoOfElementsInBatchRequest, batchEndpoints, securityKeyName) {
        return function(fields, options, originalCallback) {
            var queryParams = {},
                bodyParams = {},
                callback = originalCallback,
                rawBatchItems,
                endpoint;

            queryParams.key = utils.required(security.getKey(securityKeyName));

            rawBatchItems = utils.required(options.batchItems);

            fields = contentTypeConfigurer.setField(fields);
            bodyParams.batchItems = rawBatchItems.map(function(item) {
                var requestParams = createRequestParams(fields, contentTypeConfigurer.setValue(item)),
                    pathParams = requestParams.pathParams,
                    queryParams = requestParams.queryParams,
                    postParams = requestParams.postParams,
                    request;

                request = {
                    query: urlBuilder(batchEndpoints.single, pathParams, queryParams)
                };

                if (!_.isEmpty(postParams)) {
                    request.post = postParams;
                }

                return request;
            });

            if (bodyParams.batchItems.length <= maxNoOfElementsInBatchRequest) {
                endpoint = batchEndpoints.batchSync;
            } else {
                //If batch request is async - set redirectMode to manual and handle download of a result
                endpoint = batchEndpoints.batch;
                queryParams.redirectMode = 'manual';
                callback = asyncRedirectModeCallbackFactory(originalCallback, options);
            }

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail,
                requestType: 'batch'
            });
        };
    };
});



// WEBPACK FOOTER //
// ./rest/request/batchRequestServiceFactory.js